import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import { Link } from 'react-router-dom';
import { Users, ArrowRight } from 'lucide-react';

export default function NousRejoindrePage() {
  return (
    <div style={{ background: 'var(--bg, #FBF7F1)', minHeight: '100vh' }}>
      <Header />
      <div className="container-ose section-py">
        <div className="max-w-2xl">
          <h1 className="font-display text-3xl font-bold mb-4" style={{ color: 'var(--text)', letterSpacing: '-0.02em' }}>Rejoignez Show Événement</h1>
          <p className="text-base mb-8" style={{ color: 'rgba(255,255,255,0.6)', lineHeight: '1.7' }}>
            Vous êtes passionné(e) par l'événementiel ? Rejoignez notre équipe dynamique basée dans le Lot.
          </p>
          <div className="p-6 rounded-xl mb-6" style={{ background: '#FFFFFF', border: '1px solid var(--border)' }}>
            <div className="flex items-center gap-3 mb-4">
              <Users size={24} style={{ color: 'var(--teal)' }} />
              <h2 className="font-semibold" style={{ color: 'var(--ink)' }}>Postes ouverts</h2>
            </div>
            <ul className="space-y-3">
              {[
                { role: 'Chauffeur-livreur', type: 'CDI / Temps partiel', zone: 'Figeac et alentours' },
                { role: 'Animateur événementiel', type: 'Freelance / Extras', zone: 'Lot (46)' },
                { role: 'Commercial(e) local(e)', type: 'CDI', zone: 'Lot, Aveyron' },
              ].map((p, i) => (
                <li key={`list-${i}`} className="flex flex-wrap items-center justify-between gap-2 py-2" style={{ borderBottom: '1px solid #2A2A2A' }}>
                  <div>
                    <p className="text-sm font-semibold" style={{ color: 'var(--ink)' }}>{p.role}</p>
                    <p className="text-xs" style={{ color: 'rgba(26,26,46,0.5)' }}>{p.type} — {p.zone}</p>
                  </div>
                  <span className="px-2 py-1 rounded-full text-xs" style={{ background: 'rgba(61,220,151,0.12)', color: '#3DDC97' }}>Ouvert</span>
                </li>
              ))}
            </ul>
          </div>
          <a href="mailto:showevenementiel@gmail.com" className="btn-gold px-6 py-3 rounded-xl text-sm font-semibold inline-flex items-center gap-2">
            Envoyer ma candidature <ArrowRight size={16} />
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}
